import ReactPlaceholder from 'react-placeholder'
import { RectShape, TextBlock } from 'react-placeholder/lib/placeholders'

const placeholderColor = '#E6E6E6'
const singlePlaceHolder = (
    <div className=" mt-16 my-awesome-placeholder border border-gray-300 rounded-2xl overflow-hidden">
        <RectShape color={placeholderColor} className={'w-full relative h-0 pb-[100%]'} />
        <div
            className={
                'flex-1 flex flex-col  tracking-0-04em  text-center py-2 px-3   lg:pt-4 lg:pb-5 lg:px-6   xl:pt-6 xl:pb-8 xl:px-10   2xl:pt-9 2xl:pb-11 2xl:px-12  productDetailContent '
            }
        >
            <TextBlock rows={7} color={placeholderColor} className={'flex-1 py-4 '} />
            <div
                className={
                    'flex   flex-col xs:flex-row lg:text-4xl xl:text-5xl 2xl:text-6xl justify-between items-center font-fk_screamer text-2xl tracking-0-03em gap-2 xs:gap-3 '
                }
            >
                <TextBlock rows={1} color={placeholderColor} />
                <RectShape color={placeholderColor} className="px-4 py-6 rounded-xl">
                    <TextBlock rows={3} color={placeholderColor} />
                </RectShape>
            </div>
        </div>
    </div>
)
const awesomePlaceholder = (
    <div className={'productListWrapper'}>
        {singlePlaceHolder}
        {singlePlaceHolder}
        {singlePlaceHolder}
        {singlePlaceHolder}
        {singlePlaceHolder}
        {singlePlaceHolder}
    </div>
)

const ProductPlaceHolder = ({ data, children }) => {
    return (
        <ReactPlaceholder showLoadingAnimation ready={data} customPlaceholder={awesomePlaceholder}>
            {children}
        </ReactPlaceholder>
    )
}

export default ProductPlaceHolder
